import {  HttpHeaders } from '@angular/common/http';
import { Injectable, Component, Inject} from '@angular/core'
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
@Injectable({
  providedIn: 'root'
})
export class corHGlobal {
  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService) {
  }
  public CORSHEADERS = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
    .set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE')
    .set('Access-Control-Allow-Headers', 'X-Requested-With,content-type')
    .set('Access-Control-Allow-Credentials', 'true')

  public CORSHEADERSFILE = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
    .set('Access-Control-Allow-Credentials', 'true')
  cambioToken(datos) {
    this.CORSHEADERS = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE')
      .set('Access-Control-Allow-Headers', 'X-Requested-With,content-type')
      .set('Access-Control-Allow-Credentials', 'true')
      .set('Authorization', datos);

    this.CORSHEADERSFILE = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE')
      .set('Access-Control-Allow-Headers', 'X-Requested-With,content-type')
      .set('Access-Control-Allow-Credentials', 'true')
      .set('Authorization', datos);
  }

}



